<script lang="ts" setup>
// PROPS
interface Props {
  items: any[];
  title?: string;
  noItemsText?: string;
}

withDefaults(defineProps<Props>(), {
  items: undefined,
  title: '',
  noItemsText: 'Not added yet',
});
</script>

<template>
  <div class="showroom-view pb-10px">
    <div v-if="title" class="showroom-section-subtitle pt-10px pb-10px text--uppercase">
      {{ title }}
    </div>
    <div class="showroom-container border-radius-4">
      <div v-if="!items?.length" class="no-item">
        {{ noItemsText }}
      </div>
      <div
        v-else
        class="showroom-list flex flex-wrap grid-gap-20px grid-gap-10px--xs pl-20px ml-15px"
      >
        <div
          v-for="(itemName, index) in items"
          :key="index"
          class="showroom-list-element pl-20px pb-5px pt-5px flex"
        >
          <div class="disc mr-5px" />
          <div class="text ml-5px">
            {{ itemName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '/assets/scss/variables' as variables;
@forward '/assets/scss/skeletons';

.showroom-list {
  overflow: hidden; // Hide unwanted borders for each flex row
}

.showroom-container {
  padding: 10px 0;
}

.showroom-list-element {
  width: 200px;
  margin-left: -21px;
  margin-right: 21px;
  border-left: 1px solid var(--grey-4);

  .disc::before {
    content: '';
    display: inline-block;
    border-radius: 50%;
    background: var(--blue-3);
    width: 12px;
    height: 12px;
    transform: scale(0.5, 0.5);
    vertical-align: middle;
    margin-bottom: 1.5px;
  }

  .text {
    position: relative;
    word-break: break-all;
    text-align: start;
  }
}
</style>
